<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Users</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full mr-4" @reset="reset">
<!--        <label class="block text-gray-700">Role:</label>-->
<!--        <select v-model="form.role" class="mt-1 w-full form-select">-->
<!--          <option :value="null" />-->
<!--          <option value="user">User</option>-->
<!--          <option value="owner">Owner</option>-->
<!--        </select>-->
          <label class="block text-gray-700">Type</label>
          <select v-model="form.type" class="mt-1 w-full form-select">
              <option :value="null">All</option>
              <option value="customer">Customer</option>
              <option value="staff">Staff</option>
          </select>

        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-primary" :href="route('users.create')">
        <span>Create</span>
        <span class="hidden md:inline">User</span>
      </inertia-link>
    </div>
    <UsersTable :users="users" />
    <Pagination :links="users.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import UsersTable from "./Partials/UsersTable.vue";
import Pagination from "../../../Shared/Pagination.vue";

export default {
  metaInfo: { title: 'Users' },
  layout: Layout,
  components: {
    Pagination,
    UsersTable,
    Icon,
    SearchFilter,
  },
  props: {
    users: Object,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        type: this.filters.type,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('users', Object.keys(query).length ? query : { remember: 'forget' }), {}, { preserveState: true })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
